import React, {
  ComponentRef,
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react';

import { FiAlertCircle } from 'react-icons/fi';

import { Modal } from 'shared/presentation/components/atoms';
import { Button } from 'shared/presentation/components/molecules';

import { Container, TVariant } from './styles';

interface IConfirmProps {
  title: string;
  description: string;
  cancelText: string;
  confirmText: string;
  onConfirm: () => void;
  onClose?: () => void;
  loading?: boolean;
  variant?: TVariant;
}

type TConfirmRef = ComponentRef<typeof Modal>;

const Confirm: React.ForwardRefRenderFunction<TConfirmRef, IConfirmProps> = (
  {
    title,
    description,
    cancelText,
    confirmText,
    loading,
    variant = 'warning',
    onConfirm,
    onClose,
  },
  ref,
) => {
  const modalRef = useRef<TConfirmRef>(null);

  useImperativeHandle(
    ref,
    () => ({
      close: () => modalRef.current?.close(),
      open: () => modalRef.current?.open(),
      toggle: () => modalRef.current?.toggle(),
      visible: modalRef.current?.visible || false,
    }),
    [],
  );

  return (
    <Modal ref={modalRef} onClose={onClose} closeOnOverlayClick={!loading}>
      <Container variant={variant}>
        <FiAlertCircle />

        <div>
          <h2>{title}</h2>

          <p>{description}</p>
        </div>

        <footer>
          <Button onClick={() => modalRef.current?.close()} disabled={loading}>
            {cancelText}
          </Button>

          <Button
            variant={variant}
            onClick={onConfirm}
            loading={loading}
            hideTextWhenLoading
          >
            {confirmText}
          </Button>
        </footer>
      </Container>
    </Modal>
  );
};

export default forwardRef(Confirm);
